(function () {
  function setDrawer() {
    var hc = document.querySelector('header-component');
    if (hc && hc.dataset.menuStyle !== 'drawer') hc.dataset.menuStyle = 'drawer';
  }
  var LOGO_URL = (function () {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--p88-logo') || '';
    var m = raw.match(/url\(["']?([^"')]+)["']?\)/); return m ? m[1] : null;
  })();
  function setLogo() {
    if (!LOGO_URL) return;
    var logo = document.querySelector('.header-logo');
    if (!logo || logo.querySelector('img.pep-logo-img')) return;
    logo.innerHTML = '<img class="pep-logo-img" src="' + LOGO_URL + '" alt="PROJECT 88">';
  }
  function styleImportant(el, decls) { decls.forEach(function (s) { var i = s.indexOf(':'); el.style.setProperty(s.slice(0, i).trim(), s.slice(i + 1).trim(), 'important'); }); }

  function setupPDP() {
    var info = document.querySelector('.product-information');
    if (!info) return;
    var title = info.querySelector('h1');
    if (title) {
      title.style.setProperty('text-align', 'left', 'important');
      title.style.setProperty('text-transform', 'none', 'important');
      if (!info.querySelector('.pep-back')) {
        var a = document.createElement('a');
        a.className = 'pep-back'; a.href = '/collections/all'; a.textContent = '← Back to shop';
        styleImportant(a, ['font-family:"Courier New", monospace', 'text-transform:uppercase', 'letter-spacing:0.14em', 'font-size:11px', 'line-height:1', 'color:#8a857d', 'text-decoration:none', 'display:inline-block', 'margin:0 0 22px', 'font-weight:400']);
        title.parentNode.insertBefore(a, title);
      }
    }
    var btn = document.querySelector('add-to-cart-component button, button[name="add"]');
    var price = document.querySelector('.product-information .price__regular, .product-information .price');
    if (btn && price && !btn.querySelector('.pep-atc-price')) {
      var sp = document.createElement('span'); sp.className = 'pep-atc-price';
      sp.textContent = (price.textContent || '').trim(); btn.appendChild(sp);
      var blk = price.closest('product-price') || price; blk.style.setProperty('display', 'none', 'important');
      Array.prototype.forEach.call(info.querySelectorAll('*'), function (e) { if (e.children.length === 0 && /tax(es)? included/i.test(e.textContent || '')) e.style.setProperty('display', 'none', 'important'); });
    }
    enhancePDP(info, title);
  }

  function renderStyleRow(info, title, prods) {
    if (!prods || !prods.length || info.querySelector('.pep-style')) return;
    var row = '';
    prods.forEach(function (p) {
      var img = p.featured_image || (p.images && p.images[0]); if (!img) return;
      if (typeof img === 'object') img = img.src;
      var src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
      row += '<a class="pep-style__item" href="' + p.url + '"><img loading="lazy" src="' + src + '" alt=""></a>';
    });
    if (!row) return;
    var wrap = document.createElement('div'); wrap.className = 'pep-style';
    wrap.innerHTML = '<div class="pep-style__label">More in this style</div><div class="pep-style__row">' + row + '</div>';
    var anchor = info.querySelector('.pep-tagline') || title;
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
  }

  function enhancePDP(info, title) {
    if (!title || info.dataset.pep) return;
    info.dataset.pep = '1';
    var handle = (location.pathname.split('/products/')[1] || '').split(/[?#\/]/)[0];
    if (!handle) return;
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      try {
        var d = document.createElement('div'); d.innerHTML = p.description || '';
        var txt = (d.textContent || '').replace(/\s+/g, ' ').trim();
        var first = txt.split(/(?<=[.!?])\s/)[0];
        if (first && first.length > 2 && first.length < 140) {
          var tg = document.createElement('p'); tg.className = 'pep-tagline'; tg.textContent = first;
          styleImportant(tg, ['font-style:italic', 'color:#6f6a62', 'font-family:"Courier New", monospace', 'font-size:13px', 'line-height:1.45', 'letter-spacing:0', 'text-transform:none', 'font-weight:400', 'margin:8px 0 30px']);
          title.parentNode.insertBefore(tg, title.nextSibling);
        }
      } catch (e) {}
      return fetch('/recommendations/products.json?product_id=' + p.id + '&limit=6&intent=related').then(function (r) { return r.json(); });
    }).then(function (rec) {
      var prods = (rec && rec.products) || [];
      if (prods.length) { renderStyleRow(info, title, prods); return; }
      return fetch('/collections/all/products.json?limit=8').then(function (r) { return r.json(); }).then(function (dd) {
        var list = ((dd && dd.products) || []).filter(function (x) { return x.handle !== handle; }).slice(0, 6).map(function (x) {
          return { url: '/products/' + x.handle, featured_image: (x.images && x.images[0] && x.images[0].src) || '' };
        });
        renderStyleRow(info, title, list);
      });
    }).catch(function () {});
  }

  function tick() { setDrawer(); setLogo(); setupPDP(); }
  tick();
  ['DOMContentLoaded', 'load', 'resize', 'orientationchange'].forEach(function (ev) { window.addEventListener(ev, tick); });
  var ticks = 0; var iv = setInterval(function () { tick(); if (++ticks > 30) clearInterval(iv); }, 150);
  try { var hcEl = document.querySelector('header-component'); if (hcEl && window.MutationObserver) { new MutationObserver(tick).observe(hcEl, { attributes: true, attributeFilter: ['data-menu-style'] }); } } catch (e) {}

  function onScroll() {
    var threshold = window.innerHeight * 0.6;
    if (window.scrollY > threshold) document.body.classList.add('pep-scrolled'); else document.body.classList.remove('pep-scrolled');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll); onScroll();

  var YEAR = new Date().getFullYear();
  var CATEGORIES = [{ label: 'Parts', href: '/collections/parts' }, { label: 'Print Shop', href: '/collections/print-shop' }, { label: 'Accessories', href: '/collections/accessories' }];
  function primaryLinks() { return CATEGORIES.map(function (c) { return '<a class="pep-primary__link" href="' + c.href + '">' + c.label + '</a>'; }).join(''); }
  function build() {
    if (document.getElementById('pep-drawer')) return;
    var ov = document.createElement('div'); ov.id = 'pep-overlay'; ov.addEventListener('click', closeMenu);
    var d = document.createElement('aside'); d.id = 'pep-drawer';
    d.innerHTML =
      '<button class="pep-close" type="button" aria-label="Close menu">×</button>' +
      '<div class="pep-rule"></div>' +
      '<nav class="pep-primary">' + primaryLinks() + '</nav>' +
      '<div class="pep-menu-footer">' +
        '<form class="pep-news" method="post" action="/contact#contact_form" accept-charset="UTF-8">' +
          '<input type="hidden" name="form_type" value="customer">' +
          '<input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="contact[tags]" value="newsletter">' +
          '<div class="pep-news__row"><input class="pep-news__email" type="email" name="contact[email]" placeholder="Enter your email" aria-label="Email"><button class="pep-news__submit" type="submit">Subscribe</button></div>' +
          '<p class="pep-news__fine">By providing your email address, you agree to our <a href="/policies/privacy-policy">Privacy Policy</a>.</p>' +
        '</form>' +
        '<div class="pep-ship"><span class="pep-ship__label">Shipping to</span><span class="pep-ship__value">United Kingdom · GBP £</span><span class="pep-ship__chev">›</span></div>' +
        '<ul class="pep-secondary"><li><a href="/collections/all">Shop all</a></li><li><a href="/search">Search</a></li><li><a href="/account">Account</a></li><li><a href="/policies/privacy-policy">Legal &amp; Privacy</a></li></ul>' +
        '<p class="pep-copy">© ' + YEAR + ' PROJECT 88</p>' +
      '</div>';
    document.body.appendChild(ov); document.body.appendChild(d);
    d.querySelector('.pep-close').addEventListener('click', closeMenu);
    var em = d.querySelector('.pep-news__email');
    if (em) { ['background:transparent','border:0','box-shadow:none','border-radius:0','color:#fff','padding:0','-webkit-appearance:none'].forEach(function(s){ var p=s.split(':'); em.style.setProperty(p[0], p.slice(1).join(':'), 'important'); }); }
  }
  function openMenu() { build(); document.body.classList.add('pep-menu-open'); }
  function closeMenu() { document.body.classList.remove('pep-menu-open'); }
  document.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('summary');
    if (sum && sum.closest('header-drawer')) { e.preventDefault(); e.stopPropagation(); if (document.body.classList.contains('pep-menu-open')) closeMenu(); else openMenu(); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  if (document.readyState !== 'loading') build(); else document.addEventListener('DOMContentLoaded', build);
})();

/* ===== PROJECT 88 — newsletter signup fix (appended) =====
   The drawer newsletter form (.pep-news) was having its native submit
   intercepted, so clicking "Subscribe" did nothing. This block wires the
   form to POST the signup straight to Shopify's /contact endpoint, which
   creates a customer with email-marketing consent, and shows inline status. */
;(function () {
  function showNewsMsg(form, msg, ok) {
    var note = form.querySelector('.pep-news__note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'pep-news__note';
      note.style.cssText = 'font-size:12px;line-height:1.5;margin:10px 0 0;font-family:"Courier New",monospace;';
      var fine = form.querySelector('.pep-news__fine');
      if (fine) fine.parentNode.insertBefore(note, fine); else form.appendChild(note);
    }
    note.textContent = msg;
    note.style.color = ok ? '#8fd6a0' : '#e6a5a5';
  }
  function wireNews(form) {
    if (!form || form.dataset.pepWired) return;
    form.dataset.pepWired = '1';
    var btn = form.querySelector('.pep-news__submit');
    var email = form.querySelector('.pep-news__email');
    function handle(e) {
      if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
      var val = ((email && email.value) || '').trim();
      if (!val || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val)) {
        showNewsMsg(form, 'Please enter a valid email address.', false);
        if (email) email.focus();
        return;
      }
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = '…'; }
      fetch('/contact', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
        .then(function (r) { return { posted: /(?:customer|contact)_posted=true/.test(r.url), ok: r.ok }; })
        .then(function (res) {
          if (res.posted || res.ok) { showNewsMsg(form, 'Thanks — you are on the list.', true); form.reset(); }
          else { showNewsMsg(form, 'Sorry, that did not work. Please try again.', false); }
        })
        .catch(function () { showNewsMsg(form, 'Network error. Please try again.', false); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    }
    if (btn) btn.addEventListener('click', handle, true);
    if (email) email.addEventListener('keydown', function (e) { if (e.key === 'Enter') handle(e); }, true);
    form.addEventListener('submit', handle, true);
  }
  function scan() { var f = document.querySelector('form.pep-news'); if (f) wireNews(f); }
  document.addEventListener('click', function () { setTimeout(scan, 60); }, true);
  var n = 0, iv = setInterval(function () { scan(); if (++n > 40) clearInterval(iv); }, 200);
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
})();
